var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82373 3.25L4.88722 3.61L5.84258 15.083C5.91897 16.02 6.69575 16.739 7.62829 16.736H18.4507C19.3406 16.738 20.0956 16.078 20.2216 15.19L21.163 8.632C21.2682 7.899 20.7632 7.219 20.037 7.113C19.9735 7.104 5.21857 7.099 5.21857 7.099",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1084 10.7949H16.8594H14.1084Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1084 10.7949H16.8594",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.193 20.2026C7.49161 20.2026 7.73269 20.4466 7.73269 20.7466C7.73269 21.0476 7.49161 21.2916 7.193 21.2916C6.89439 21.2916 6.65332 21.0476 6.65332 20.7466C6.65332 20.4466 6.89439 20.2026 7.193 20.2026Z",
    fill: "#FAFAFA",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3839 20.2026C18.6825 20.2026 18.9246 20.4466 18.9246 20.7466C18.9246 21.0476 18.6825 21.2916 18.3839 21.2916C18.0853 21.2916 17.8442 21.0476 17.8442 20.7466C17.8442 20.4466 18.0853 20.2026 18.3839 20.2026Z",
    fill: "#FAFAFA",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/Buy.515cc849c2b810b330bfba1343eaf02d.svg";
export { ForwardRef as ReactComponent };